let COOKIE_CONSENT: any = null;

export async function getCookieConsent(languageId: number = 0) {
    if (COOKIE_CONSENT) return COOKIE_CONSENT;

    const NEXT_PUBLIC_SERVER = process.env.NEXT_PUBLIC_SERVER;
    const NEXT_PUBLIC_API_BASE = process.env.NEXT_PUBLIC_API_BASE;

    if (!NEXT_PUBLIC_SERVER || !NEXT_PUBLIC_API_BASE) {
        console.error('Environment variables for API are not set');
        return null;
    }

    const server = String(NEXT_PUBLIC_SERVER).replace(/\/$/, '');
    const apiBase = String(NEXT_PUBLIC_API_BASE).replace(/^\/|\/$/g, '');
    let _url: string = `${server}/${apiBase}/cookieconsent?l=${languageId}`;

    try {
        const res = await fetch(_url, { cache: 'no-store' });
        if (!res.ok) {
            console.error('Failed to fetch cookie consent from:', _url);
            return null;
        }

        COOKIE_CONSENT = await res.json();
        return COOKIE_CONSENT;
    } catch (error) {
        console.error('Error fetching cookie consent:', error);
        return null;
    }
}

export async function saveCookieConsent(data: { deny?: boolean, selectAll?: boolean, cookieOptions?: number[] }, languageId: number = 0) {
    const NEXT_PUBLIC_SERVER = process.env.NEXT_PUBLIC_SERVER;
    const NEXT_PUBLIC_API_BASE = process.env.NEXT_PUBLIC_API_BASE;

    if (!NEXT_PUBLIC_SERVER || !NEXT_PUBLIC_API_BASE) {
        console.error('Environment variables for API are not set');
        return null;
    }

    const server = String(NEXT_PUBLIC_SERVER).replace(/\/$/, '');
    const apiBase = String(NEXT_PUBLIC_API_BASE).replace(/^\/|\/$/g, '');
    let _url: string = `${server}/${apiBase}/saveconsent?l=${languageId}`;

    try {
        const res = await fetch(_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        
        if (!res.ok) {
            console.error('Failed to save cookie consent to:', _url);
            return null;
        }

        return await res.json();
    } catch (error) {
        console.error('Error saving cookie consent:', error);
        return null;
    }
}
